export class SesionPagos {

    public strCookieI?: string;
    public strCookieT?:string;

}
